// Google Sheets API helper
const SHEET_ID   = process.env.REACT_APP_SHEET_ID;
const API_KEY    = process.env.REACT_APP_SHEETS_API_KEY;
const BASE       = "https://sheets.googleapis.com/v4/spreadsheets";
const WEBAPP_URL = process.env.REACT_APP_WEBAPP_URL;

const WINNER_ROW = 43;

// PLAYOFF lehel on iga vooru vahel üks päiserida (nt "POOLFINAALID"), mistõttu
// match id -> Sheetsi rida ei ole lineaarne pärast R32. Hardcoded mapping,
// kinnitatud kasutaja screenshottidelt (R32 read 5-20, R16 22-29, QF 31-34,
// SF 36-37, 3rd 39, FINAL 41, WINNER 43).
const PLAYOFF_ID_TO_ABSROW = {
  101:5, 102:6, 103:7, 104:8, 105:9, 106:10, 107:11, 108:12,
  109:13,110:14,111:15,112:16,113:17,114:18,115:19,116:20,
  117:22,118:23,119:24,120:25,121:26,122:27,123:28,124:29,
  125:31,126:32,127:33,128:34,
  129:36,130:37,
  131:39,
  132:41,
};

// ── match id → sheet row mapping (hardcoded, derived from actual sheet structure) ──
// sheetIdx (0-based match count) → absRow (1-based sheet row)
const SHEET_IDX_TO_ABSROW = {
  0:5,  1:6,  2:8,  3:10, 4:12, 5:14, 6:15, 7:17, 8:19, 9:21,
  10:23,11:25,12:27,13:29,14:31,15:33,16:35,17:36,18:38,19:39,
  20:41,21:43,22:44,23:46,24:48,25:50,26:51,27:53,
  // row 54 = "1-0" anomaly
  28:55,29:57,30:58,31:60,32:62,33:64,34:65,35:67,
  // row 68 = "2" anomaly
  36:69,37:71,38:73,39:75,40:77,41:79,42:80,43:82,
  44:84,45:86,46:87,47:89,
  // R3 block 1 (rows 90-95)
  48:91,49:92,50:94,51:95,
  // row 96 = empty line between R3 groups
  52:97, 53:98,
  54:100,55:101,56:103,57:104,58:106,59:107,
  60:109,61:110,62:112,63:113,64:115,65:116,
  66:118,67:119,68:121,69:122,70:124,71:125,
};

// sheetIdx → match id (from matches.js)
const SHEET_TO_MATCH = {
  0:1,  1:2,  2:7,  3:19, 4:8,  5:13, 6:14, 7:20, 8:25, 9:31,
  10:26,11:32,12:43,13:37,14:44,15:38,16:49,17:50,18:55,19:56,
  20:61,21:67,22:68,23:62,24:3, 25:9, 26:10,27:4, 28:21,29:15,
  30:16,31:22,32:33,33:27,34:28,35:34,36:45,37:39,38:46,39:40,
  40:57,41:52,42:51,43:58,44:63,45:69,46:70,47:64,48:11,49:12,
  50:17,51:18,52:5, 53:6, 54:29,55:30,56:35,57:36,58:23,59:24,
  60:53,61:54,62:47,63:48,64:41,65:42,66:71,67:72,68:65,69:66,
  70:59,71:60,
};

// match id → sheetIdx (reverse)
const MATCH_TO_SHEET = {};
Object.entries(SHEET_TO_MATCH).forEach(([si, mid]) => { MATCH_TO_SHEET[mid] = Number(si); });

// Build static groupMatchRows from hardcoded mapping
function buildGroupMatchRows() {
  return Object.entries(SHEET_IDX_TO_ABSROW).map(([si, absRow]) => ({
    sheetIdx: Number(si),
    absRow,
    arrIdx: absRow - 4,  // 0-based index into arrays read from row 4
  }));
}

export function matchIdToSheetRow(matchId) {
  const si = MATCH_TO_SHEET[matchId];
  return si !== undefined ? SHEET_IDX_TO_ABSROW[si] : null;
}

// ── API helpers ───────────────────────────────────────────────────────────
export async function readRange(range) {
  const url = `${BASE}/${SHEET_ID}/values/${encodeURIComponent(range)}?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Sheets read error: ${res.status}`);
  return (await res.json()).values || [];
}

async function batchRead(ranges) {
  const params = ranges.map(r => `ranges=${encodeURIComponent(r)}`).join("&");
  const url = `${BASE}/${SHEET_ID}/values:batchGet?${params}&key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Batch read error: ${res.status}`);
  return ((await res.json()).valueRanges || []).map(vr => vr.values || []);
}

export async function writeValue(sheet, row, col, value) {
  if (!WEBAPP_URL) { console.warn("WEBAPP_URL puudub"); return false; }
  try {
    const res = await fetch(WEBAPP_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ sheet, row, col, value }),
    });
    const data = await res.json();
    if (data.error) { console.error("WebApp viga:", data.error); return false; }
    return !!data.ok;
  } catch (err) {
    console.error("writeValue viga:", err);
    return false;
  }
}

// ── Kõik põhiandmed ühes päringus ────────────────────────────────────────
export async function loadInitialData() {
  const gmr = buildGroupMatchRows();

  const [namesRows, groupResultRows, playoffResultRows, standingsRows] =
    await batchRead([
      "ALAGRUPID!H2:AV2",
      "ALAGRUPID!G4:G200",
      "PLAYOFF!F5:F50",
      "KOKKU!A3:F24",
    ]);

  const names = (namesRows[0] || []).filter((_, i) => i % 2 === 0);

  // groupById: matchId → result string
  const groupById = {};
  gmr.forEach(({ sheetIdx, arrIdx }) => {
    const mid = SHEET_TO_MATCH[sheetIdx];
    if (mid !== undefined) {
      groupById[mid] = groupResultRows[arrIdx]?.[0] || "";
    }
  });

  // playoffResultRows on lineaarne massiiv realt 5 alates (sisaldab tühje
  // päiserea kohti). Teisendame matchId -> result objektiks, kasutades
  // PLAYOFF_ID_TO_ABSROW - 5 array indeksina.
  const playoffById = {};
  Object.entries(PLAYOFF_ID_TO_ABSROW).forEach(([mid, absRow]) => {
    playoffById[mid] = playoffResultRows[absRow - 5]?.[0] || "";
  });

  const standings = standingsRows.map(r => ({
    rank:    r[0] || "",
    name:    r[1] || "",
    group:   Number(r[2]) || 0,
    playoff: Number(r[3]) || 0,
    winner:  Number(r[4]) || 0,
    total:   Number(r[5]) || 0,
  }));

  return { names, results: { groupById, playoffById }, standings, groupMatchRows: gmr };
}

// ── Ühe mängija ennustused ────────────────────────────────────────────────
export async function loadPlayerPredictions(playerIndex, groupMatchRows) {
  const gmr = groupMatchRows || buildGroupMatchRows();
  const colAG     = colToLetter(8 + playerIndex * 2);
  const colPO     = colToLetter(7 + playerIndex * 4);
  const colPO_nep = colToLetter(7 + playerIndex * 4 + 2);

  const [agAllRows, poRows, nepRows, winnerRows] = await batchRead([
    `ALAGRUPID!${colAG}4:${colAG}200`,
    `PLAYOFF!${colPO}5:${colPO}50`,
    `PLAYOFF!${colPO_nep}5:${colPO_nep}50`,
    `PLAYOFF!${colPO}${WINNER_ROW}:${colPO}${WINNER_ROW}`,
  ]);

  const predById = {};
  gmr.forEach(({ sheetIdx, arrIdx }) => {
    const mid = SHEET_TO_MATCH[sheetIdx];
    if (mid !== undefined) {
      predById[mid] = agAllRows[arrIdx]?.[0] || "";
    }
  });

  const playoffById = {};
  const playoffNepById = {};
  Object.entries(PLAYOFF_ID_TO_ABSROW).forEach(([mid, absRow]) => {
    playoffById[mid]    = poRows[absRow - 5]?.[0] || "";
    playoffNepById[mid] = nepRows[absRow - 5]?.[0] || "";
  });

  return {
    predById,
    playoffById,
    playoffNepById,
    winner: winnerRows[0]?.[0] || "",
  };
}

// ── Kõigi mängijate ennustused koondvaate jaoks ───────────────────────────
export async function loadAllPredictions(playerCount, groupMatchRows) {
  const gmr = groupMatchRows || buildGroupMatchRows();
  const lastAGcol = colToLetter(8 + (playerCount - 1) * 2);
  const lastPOcol = colToLetter(7 + (playerCount - 1) * 4);
  const lastPOnep = colToLetter(7 + (playerCount - 1) * 4 + 2);

  const [agAllBlock, poBlock, nepBlock, winnerRow] = await batchRead([
    `ALAGRUPID!H4:${lastAGcol}200`,
    `PLAYOFF!G5:${lastPOcol}50`,
    `PLAYOFF!I5:${lastPOnep}50`,
    `PLAYOFF!G${WINNER_ROW}:${lastPOcol}${WINNER_ROW}`,
  ]);

  // agBlockByMatchId: matchId → row data array
  const agBlockByMatchId = {};
  gmr.forEach(({ sheetIdx, arrIdx }) => {
    const mid = SHEET_TO_MATCH[sheetIdx];
    if (mid !== undefined) {
      agBlockByMatchId[mid] = agAllBlock[arrIdx] || [];
    }
  });

  const poBlockByMatchId = {};
  const nepBlockByMatchId = {};
  Object.entries(PLAYOFF_ID_TO_ABSROW).forEach(([mid, absRow]) => {
    poBlockByMatchId[mid]  = poBlock[absRow - 5] || [];
    nepBlockByMatchId[mid] = nepBlock[absRow - 5] || [];
  });

  return { agBlockByMatchId, poBlockByMatchId, nepBlockByMatchId, winnerRow: winnerRow[0] || [] };
}

// ── Ennustuse salvestamine ────────────────────────────────────────────────
export async function savePrediction(matchId, playerIndex, score, groupMatchRows) {
  const absRow = matchIdToSheetRow(matchId);
  if (!absRow) { console.error("Match not found:", matchId); return false; }
  const col = 8 + playerIndex * 2;
  return writeValue("ALAGRUPID", absRow, col, score);
}

// ── Võitja salvestamine ───────────────────────────────────────────────────
export async function saveWinnerPrediction(playerIndex, value) {
  return writeValue("PLAYOFF", WINNER_ROW, 7 + playerIndex * 4, value);
}

// matchId -> absRow PLAYOFF lehel (mitte-lineaarne struktuur, päiseridade tõttu)
export function playoffMatchIdToRow(matchId) {
  return PLAYOFF_ID_TO_ABSROW[matchId] || null;
}

export const MATCH_TO_SHEET_EXPORT = MATCH_TO_SHEET;
export const PLAYOFF_ID_TO_ABSROW_EXPORT = PLAYOFF_ID_TO_ABSROW;

function colToLetter(n) {
  let s = "";
  while (n > 0) {
    n--;
    s = String.fromCharCode(65 + (n % 26)) + s;
    n = Math.floor(n / 26);
  }
  return s;
}
